import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import Accordion from '@mui/material/Accordion';
import { Button, TextField, Card, Grid, CardHeader, CardContent, Typography, Box } from '@mui/material';
import { SelectField } from 'components';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { enqueueSnackbar } from 'actions';
import { SetFormState, ToggleSiteTrackerUpdateConfirmation, UpdateSites } from '../../../../actions/SiteTrackerActions';

const SiteTrackerUpdateForm = (props) => {
	const { open, fieldType, fieldTypeValue, fieldName, fieldValue, phase, ...rest } = props;
	const dispatch = useDispatch();
	const tableId = useSelector((state) => state.siteTrackerReducer.tableId);
	const userId = useSelector(state => state.session.user.id);
	const role = useSelector(state => state.session.user.role);
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector(state => state.siteTrackerReducer.formState);

	const _handleClose = () => {
		dispatch(ToggleSiteTrackerUpdateConfirmation(false));
	};

	const _handleUpdate = () => {
		dispatch(UpdateSites(userId, role, fieldType, fieldTypeValue, fieldName, fieldValue, phase));
		dispatch(ToggleSiteTrackerUpdateConfirmation(false));
		dispatch(enqueueSnackbar({ message: 'Update Done', options: { variant: 'info' } }));
	};

	return (
		<div>
			<Dialog open={open} onClose={_handleClose}>
				<DialogTitle>{fieldType}</DialogTitle>
				<DialogContent>
					<Box
					// component="form"
					// sx={{
					// 	'& > :not(style)': { m: 1, width: '250ch' },
					// }}
					// noValidate
					// autoComplete="off"
					>
						<Grid>
							<Typography variant="h6">
								{`Are you sure you want to update all sites for this 
								[${fieldType}]: ${fieldTypeValue} 
								- 
								[${fieldName}]: ${fieldValue}?`}
							</Typography>
						</Grid>
					</Box>
				</DialogContent>
				<DialogActions>
					<Grid>
						<Button onClick={_handleUpdate}>Update</Button>
					</Grid>
					<Grid>
						<Button onClick={_handleClose}>Close</Button>
					</Grid>
				</DialogActions>
			</Dialog>
		</div>
	);
};

SiteTrackerUpdateForm.propTypes = {
	open: PropTypes.bool,
	fieldType: PropTypes.string,
	fieldTypeValue: PropTypes.string,
	fieldName: PropTypes.string,
	fieldValue: PropTypes.string
};

export default SiteTrackerUpdateForm;
